import { IconClose } from '@redteclab/icons'
import { useState } from 'react'

import {
  LOGIN_PASSKEY_BUTTON_CLICKED,
  LOGIN_PASSKEY_DISLIKE_BUTTON_CLICKED,
  LOGIN_PASSKEY_DONT_KNOW_BUTTON_CLICKED,
  LOGIN_PASSKEY_LIKE_BUTTON_CLICKED,
  REGISTER_PASSKEY_BUTTON_CLICKED,
  REGISTER_PASSKEY_DISLIKE_BUTTON_CLICKED,
  REGISTER_PASSKEY_DONT_KNOW_BUTTON_CLICKED,
  REGISTER_PASSKEY_LIKE_BUTTON_CLICKED,
} from 'shared/experiments/consts/events'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'

import './PasskeyFakeDoorContent.scss'
import KeyIcon from './Icons/KeyIcon'
import LikeIcon from './Icons/LikeIcon'

enum PasskeyFakeDoorModalType {
  START,
  MAIN,
  THANKS,
  EXPLANATION,
  CLOSED,
}

type PasskeyFakeDoorContentProps = {
  isLogin: boolean
}

const PasskeyFakeDoorContent: React.FC<PasskeyFakeDoorContentProps> = ({
  isLogin,
}) => {
  const [passkeyFakeDoorModalType, setPasskeyFakeDoorModalType] = useState(
    PasskeyFakeDoorModalType.START
  )

  const PasskeyFakeDoorModalStart = () => {
    return (
      <button
        type="button"
        onClick={() => {
          if (isLogin) {
            trackOptimizelyEvent(LOGIN_PASSKEY_BUTTON_CLICKED)
          } else {
            trackOptimizelyEvent(REGISTER_PASSKEY_BUTTON_CLICKED)
          }
          setPasskeyFakeDoorModalType(PasskeyFakeDoorModalType.MAIN)
        }}
        className="o-PasskeyFakeDoorContent__button--invisible "
      >
        <KeyIcon className="o-PasskeyFakeDoorContent__icon" />
        <p className="o-PasskeyFakeDoorContent__label u-margin-xx-small--bottom">
          {isLogin ? 'Mit Passkey einloggen' : 'Passkey verwenden'}
        </p>
      </button>
    )
  }

  const PasskeyFakeDoorMainModal = () => {
    return (
      <div className="o-PasskeyFakeDoorContent__modal">
        <div className="l-flex l-flex--start l-flex--distribute-space">
          <h3 className="o-PasskeyFakeDoorContent__title">
            Per Passkey können Sie sich einfacher anmelden
          </h3>
          <button
            type="button"
            onClick={() => {
              setPasskeyFakeDoorModalType(PasskeyFakeDoorModalType.CLOSED)
            }}
            className="o-PasskeyFakeDoorContent__button--invisible"
          >
            <IconClose
              height={'1.5rem'}
              width={'1.5rem'}
              className="o-PasskeyFakeDoorContent__close"
            />
          </button>
        </div>
        <p>
          Möchten Sie in Zukunft die Passkey-Funktion für eine bequemere und
          sichere Anmeldung nutzen?
        </p>
        <div className="l-flex u-margin--bottom">
          <button
            type="button"
            className="o-PasskeyFakeDoorContent__button--invisible u-margin-x-small--right"
            onClick={() => {
              setPasskeyFakeDoorModalType(PasskeyFakeDoorModalType.THANKS)
              if (isLogin) {
                trackOptimizelyEvent(LOGIN_PASSKEY_LIKE_BUTTON_CLICKED)
              } else {
                trackOptimizelyEvent(REGISTER_PASSKEY_LIKE_BUTTON_CLICKED)
              }
            }}
          >
            <LikeIcon className="o-PasskeyFakeDoorContent__likeIcon" />
          </button>
          <button
            type="button"
            className="o-PasskeyFakeDoorContent__button--invisible"
            onClick={() => {
              setPasskeyFakeDoorModalType(PasskeyFakeDoorModalType.THANKS)
              if (isLogin) {
                trackOptimizelyEvent(LOGIN_PASSKEY_DISLIKE_BUTTON_CLICKED)
              } else {
                trackOptimizelyEvent(REGISTER_PASSKEY_DISLIKE_BUTTON_CLICKED)
              }
            }}
          >
            <LikeIcon className="o-PasskeyFakeDoorContent__dislikeIcon" />
          </button>
        </div>
        <button
          className="o-PasskeyFakeDoorContent__button--invisible"
          onClick={() => {
            setPasskeyFakeDoorModalType(PasskeyFakeDoorModalType.EXPLANATION)
            if (isLogin) {
              trackOptimizelyEvent(LOGIN_PASSKEY_DONT_KNOW_BUTTON_CLICKED)
            } else {
              trackOptimizelyEvent(REGISTER_PASSKEY_DONT_KNOW_BUTTON_CLICKED)
            }
          }}
        >
          <p className="o-PasskeyFakeDoorContent__dontKnowLabel">
            Ich weiß nicht, was eine Passkey Funktion ist
          </p>
        </button>
      </div>
    )
  }

  const PasskeyFakeDoorModalThanks = () => {
    return (
      <div className="o-PasskeyFakeDoorContent__modal">
        <div className="l-flex l-flex--start l-flex--distribute-space">
          <h3 className="o-PasskeyFakeDoorContent__title">
            Danke für Ihre Hilfe
          </h3>
          <button
            type="button"
            onClick={() => {
              setPasskeyFakeDoorModalType(PasskeyFakeDoorModalType.CLOSED)
            }}
            className="o-PasskeyFakeDoorContent__button--invisible"
          >
            <IconClose
              height={'1.5rem'}
              width={'1.5rem'}
              className="o-PasskeyFakeDoorContent__close"
            />
          </button>
        </div>
        <p>
          Wir denken gerade darüber nach, einen Passcode einzuführen. Dazu
          befragen wir unsere Kunden.
        </p>
        <div>
          <button
            type="button"
            className="o-PasskeyFakeDoorContent__button--invisible"
            onClick={() => {
              setPasskeyFakeDoorModalType(PasskeyFakeDoorModalType.CLOSED)
            }}
          >
            <p className="o-PasskeyFakeDoorContent__continueShoppingLabel">
              Weiter einkaufen
            </p>
          </button>
        </div>
      </div>
    )
  }

  const PasskeyFakeDoorModalExplanation = () => {
    return (
      <div className="o-PasskeyFakeDoorContent__modal">
        <div className="l-flex l-flex--start l-flex--distribute-space">
          <h3 className="o-PasskeyFakeDoorContent__title">
            Was ist ein Passkey?
          </h3>
          <button
            type="button"
            onClick={() => {
              setPasskeyFakeDoorModalType(PasskeyFakeDoorModalType.CLOSED)
            }}
            className="o-PasskeyFakeDoorContent__button--invisible"
          >
            <IconClose
              height={'1.5rem'}
              width={'1.5rem'}
              className="o-PasskeyFakeDoorContent__close"
            />
          </button>
        </div>
        <p>
          Mit einem Passkey können Sie sich sicher und einfach ohne Passwort
          anmelden. Stattdessen nutzen Sie Fingerabdruck, Gesichtserkennung oder
          PIN, zum Beispiel über Ihr Smartphone.
        </p>
        <div>
          <button
            type="button"
            className="o-PasskeyFakeDoorContent__button--invisible"
            onClick={() => {
              setPasskeyFakeDoorModalType(PasskeyFakeDoorModalType.CLOSED)
            }}
          >
            <p className="o-PasskeyFakeDoorContent__continueShoppingLabel">
              Weiter einkaufen
            </p>
          </button>
        </div>
      </div>
    )
  }

  const renderSwitch = () => {
    switch (passkeyFakeDoorModalType) {
      case PasskeyFakeDoorModalType.START:
        return <PasskeyFakeDoorModalStart />
      case PasskeyFakeDoorModalType.MAIN:
        return <PasskeyFakeDoorMainModal />
      case PasskeyFakeDoorModalType.THANKS:
        return <PasskeyFakeDoorModalThanks />
      case PasskeyFakeDoorModalType.EXPLANATION:
        return <PasskeyFakeDoorModalExplanation />
      case PasskeyFakeDoorModalType.CLOSED:
        return null
      default:
        return <PasskeyFakeDoorModalStart />
    }
  }

  return <>{renderSwitch()}</>
}

export default PasskeyFakeDoorContent
